import { IdentifierDTO } from '@zazume/zzm-base';
import { doGet } from '../../helpers';
import { PhoneCall } from '#/models/phoneCall/PhoneCall';

export const phoneCalls = {
  getById: (id: IdentifierDTO) => () =>
    doGet<PhoneCall>(`/dashboard/phone-calls/${id}`)
};
